import { render, staticRenderFns } from "./NewQuiz.vue?vue&type=template&id=5b104c78&scoped=true&"
import script from "./NewQuiz.vue?vue&type=script&lang=js&"
export * from "./NewQuiz.vue?vue&type=script&lang=js&"
import style0 from "./NewQuiz.vue?vue&type=style&index=0&id=5b104c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b104c78",
  null
  
)

export default component.exports